export const SET_SIZE = 'reports/SET_SIZE';
export const SET_IMAGE = 'reports/SET_IMAGE';
export const SET_DEFECT_RATING_MODE = 'reports/SET_DEFECT_RATING_MODE';
export const SET_ITEM = 'reports/SET_ITEM';
export const SET_TABNAME = 'reports/SET_TABNAME';
export const SET_REPORT = 'reports/SET_REPORT';
export const SHOW_IN_VIEW = 'reports/SHOW_IN_VIEW';
export const israeliOrganizationIds = [201, 220];
export const STRUCTURE_DISTRESS = 'Structure Distress';
export const SUMMARY = 'Summary';
export const INSPECTION_ITEMS = 'Inspection items';
export const STRUCTURE_INFO = 'Structure Info';
export const MAINTENANCE = 'Maintenance';
export const CANT_BE_SURVEYED = 'Cannot be surveyed';
export const SUPPEMENTAL_FILES = 'Supplemental files'
export const CHARTS = 'Charts';
export const UPDATED_BY = 'Updated by';